import {
  LEGACY_SW_CACHE_NAMES,
  SW_CACHE_NAME,
  SW_CACHE_PREFIX,
} from '@/constants/appIdentity'

function shouldDeleteCache(cacheName) {
  if (cacheName === SW_CACHE_NAME) return false
  if (cacheName.startsWith(SW_CACHE_PREFIX)) return true
  if (LEGACY_SW_CACHE_NAMES.includes(cacheName)) return true
  return false
}

async function cleanupLegacyCaches() {
  if (!('caches' in window)) return
  try {
    const names = await caches.keys()
    await Promise.all(
      names.filter(shouldDeleteCache).map((name) => caches.delete(name))
    )
  } catch (e) {
    // ignore
  }
}

export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return
  }

  window.addEventListener('load', () => {
    cleanupLegacyCaches()

    const base = String(process.env.BASE_URL || '/').replace(/\/?$/, '/')
    navigator.serviceWorker.register(`${base}sw.js`, { scope: base }).catch((error) => {
      console.warn('Service Worker注册失败:', error)
    })
  })
}
